import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pifelseif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python If Else If Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python if else if tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners " />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python if else if,python if else one line,python inline if else,python if else elseif,python if else assignment
,python if else lambda,python if else expression,python if else if syntax,python if else boolean,python if else exercises" />
<link rel="canonical" href="https://www.codeexampler.com/python-if-else-if" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">python if else if Statement</h1>
    
    <div className="first">
        <a href="/python-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <h2 className="mt-4"> python if-else if Syntax:
</h2>


       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-6">if</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">condition</span>
                <span className="qwerty-1">)</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statement</span>
            {"\n"}
                <span className="qwerty-6">elif</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">condition</span>
                <span className="qwerty-1">)</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statement</span>
            {"\n"}
                <span className="qwerty-6">else</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statement</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>  


<h2 className="mt-4 mh2">Python if else if Statement Examples:</h2>


<h2 className='headings'>Q-Write a program to find maximum among 3 nummbers in if-else if statement?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">20</span>
                  <span className="qwerty-1">;</span>
              <span className="qwerty-4"> b</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">40</span>
                  <span className="qwerty-1">;</span>
              <span className="qwerty-4"> c</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">60</span>
                  <span className="qwerty-1">;</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-5"> and </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">c</span>
                
                  <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty">a</span>
                  <span className="qwerty-10"> is greater </span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">elif</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-5"> and </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty">b </span>
                  <span className="qwerty-10">is greater</span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty">c</span>
                  <span className="qwerty-10"> is greater</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>   
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-3">c </span>
                          <span className="qwerty-8">is greater</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>     

<h2 className='headings'>Q-Write a program to find no is positve, negative, zero in Python if else if Statement?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">i</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">45</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">0</span>
                  <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Positive </span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">elif</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty">&#60;</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Negative</span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10"> Zero</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>             {"\n"}
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-3">Positive </span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div> 



<h2 className='headings'>Q-Write a program to input how is the maximum no in Python if else if Statement?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a no :</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">b</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter b no :</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">c</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter c no :</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-7"> and </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Max=</span>
                  <span className="qwerty-5">%d</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-4">%a</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">elif</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty-7"> and </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Max=</span>
                  <span className="qwerty-5">%d</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-4">%b</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Max=</span>
                  <span className="qwerty-5">%d</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-4">%c</span>
                  <span className="qwerty-1">)</span>             {"\n"}
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter a no : </span>
                          <span className="qwerty-3">45</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter b no : </span>
                          <span className="qwerty-3">24</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter c no : </span>
                          <span className="qwerty-3">34</span>
                          {"\n"}    
                          <span className="qwerty-4">Max = </span>
                          <span className="qwerty-2">45</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>   


<p className="mt-4 para">If you don't know about input in Python so check on <a href="https://www.codeexampler.com/python-lambda"> Python Lambda tutorial for Beginners</a></p>



<h2 className='headings'>Q-Write a program to input check percentage no in Python if else if Statement?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">percentage</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">float</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a per :</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> percentage</span>
                 <span className="qwerty">&#62;=</span>
                 <span className="qwerty-8">80</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">A</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">elif</span>
                 <span className="qwerty-4"> percentage</span>
                 <span className="qwerty">&#62;=</span>
                 <span className="qwerty-8">50</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">B</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">C</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span> 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter a per : </span>
                          <span className="qwerty-3">42.8</span>
                          {"\n"}    
                          <span className="qwerty-4">C </span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>   

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pifelseif;